import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=4c857c78&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/management.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/themes/default/checkbox.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports